import React from 'react';
export function ProofBand() {
  return <section className="py-20 border-y border-hubble-border bg-hubble-ink relative z-10" data-id="element-200">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-201">
        <h2 className="font-heading text-3xl md:text-4xl font-medium text-hubble-paper mb-4" data-id="element-202">
          Live in production across leading EHRs and payers.
        </h2>
        <p className="font-body text-[16px] md:text-[18px] text-hubble-paper/50" data-id="element-203">
          40+ tools spanning Epic, Cerner, athenahealth, UnitedHealthcare,
          Aetna, and more.
        </p>
      </div>
    </section>;
}